export default __webpack_public_path__ + "static/media/image-ph-health-statistics-w.9b5038d6.png";